import * as r from 'ramda';

import { ArtSkuTypes } from 'constants/skuTypes';

export const getArtSkuTypesByOrientation = (orientation) =>
  ArtSkuTypes.filter(r.propEq('orientation', orientation));
